import {Component} from 'react';
import "./Admin/admin.css";
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {rptEventsWithConditions} from './objects/rpt_events_with_conditions';
import {rptMoodPointsByEvent} from './objects/rpt_mood_points_by_event';
import rptEventsAudit from './eventTrackerObjects/rpt_events_audit';
import EventReportsInputModal from './event_reports_input_modal';
import ExportToExcelButton from './export_to_excel';
import rptEditEvents from './objects/rpt_edit_events';
import rptMoodPointAnalysis from './objects/rpt_mood_point_analysis';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import buildUrl from '../../objects/CommonUse/build_URL';
import config from '../../config';
import rptMissingCreditInfo from './objects/rpt_missing_credit_info';
import rptFrequencyAnalysisDetail from './objects/rpt_frequency_analysis_detail';
import rptFrequencyAnalysisSummary from './objects/rpt_frequency_analysis_summary';
import rptEventAnalysis from './objects/rpt_event_analysis';
import EditVariableEventsModal from './edit_variable_events_modal';
import DupTitlesOK from './datasets/dup_titles_ok';


class EventReports extends Component {
    constructor(props) {
        super(props);
        this.adminInfo = this.props.adminInfo();
        this.state={
            headers: setHeadersForFetch(),  
            openRptParameterModal: false,
            exportToExcelButton: false,
            eventsTrackerLoaded: false,
            eventArrLoaded: false,
            openVariableEvents: false,
            subProcess: "EventReports",
            environment: config.dataURL.currentEnv,
        };   
        this.eventsTrackerData = null;
        this.eventArrData = null;
        this.sortEventTitles = [];
    }

    editEventsCollection(){
        this.reportDataArr=[];
        this.sortConditionTableByCondName();
        this.reportDataArr = rptEditEvents(this.adminInfo.eventsData, this.conditionSortByCondName,
            this.careerConditionsSortByCondName)
        this.checkForDuplicateTitles();
        this.rptTitle = "EventsEditRpt";
        this.rptLines = this.reportDataArr;
        this.exportReportDataset();
    }

    sortConditionTableByCondName(){
        var i;
        var condName="";
        var condNameArr=[];
        var careerCondNameArr=[];
        for (i=0; i<this.adminInfo.conditionsData.length; i++){
            // convert condName from index to string
            condName = JSON.parse(JSON.stringify(this.adminInfo.conditionsData[i].condName));
            if (this.adminInfo.conditionsData[i].conditionClass === "career"){
                careerCondNameArr.push(condName);
            }else{
                condNameArr.push(condName);
            }
        }
        this.conditionSortByCondName = condNameArr.sort();
        this.careerConditionsSortByCondName = careerCondNameArr.sort();
    }

    checkForDuplicateTitles()
    {
        var i;
        var j;
        this.sortEventsByTitle();
        // check for situations where two events have the same title
        for (i=0; i < this.sortEventTitles.length - 1; i++){
            j=i+1
            const dupOK = DupTitlesOK.includes(this.sortEventTitles[i].title);
            if (this.sortEventTitles[i].title === this.sortEventTitles[j].title &&
               dupOK === false && 
               this.sortEventTitles[i].gamePhase === this.sortEventTitles[j].gamePhase &&
               this.sortEventTitles[i].careerTag === this.sortEventTitles[j].careerTag ){
                let errorObj = {fieldClass: "Complex Edit", fieldName: "event title",
                    fieldValue: this.sortEventTitles[i].title,
                    message: "This title has been found on multiple events"};
                this.reportDataArr.push(errorObj);
            }
        }
    } 
        
    sortEventsByTitle(){
        var i;
        this.eventTitles=[];
        for (i=0; i<this.adminInfo.eventsData.length; i++){
             const titleObj = {title: this.adminInfo.eventsData[i].title,
                gamePhase: this.adminInfo.eventsData[i].gamePhase,
                careerTag: this.adminInfo.eventsData[i].careerTag
             }
             this.eventTitles.push(titleObj);
        }
        this.sortEventTitles = this.eventTitles.sort();
    }
    
    rptEventHeaderList(){
        this.eventHeaderListArr = []
        for (let i=0; i<this.adminInfo.eventsData.length; i++){
            if (i === 0){
                this.eventHeaderListHeading();
            }
            this.eventNbr = i + 1;
            let eventObj = this.adminInfo.eventsData[i];
            this.buildEventHeaderListObj(eventObj);
        }
        this.rptTitle = "EventHeaderList";
        this.rptLines = this.eventHeaderListArr;
        this.exportReportDataset();
    }

    eventHeaderListHeading(){
        let headerObj = {eventNbr: "Event Nbr", eventTitle: "Event Title", description: "Event Description",
            frequency: "Frequency", condition: "Select Condition(s)", conditionConnector: "Condition Connector",
            skipCondition: "Skip Condition", selectOnCondition: "Select Cond Switch", background: "Background",
            gamePhase: "Game Phase", eventCategory: "Event Category", careerTag: "Career Tag", 
            imageDirectory: "Image Directory"};
        this.eventHeaderListArr.push(headerObj);
    }
       
    buildEventHeaderListObj(eventObj){
        let eventSelectOnCondition = false;
        let conditions = "";
        let skipConditions = "";
        let conditionConnector = "";
        if ((eventObj.conditionArr  && eventObj.conditionArr.length > 0) ||
            (eventObj.skipConditionArr  & eventObj.skipConditionArr.length > 0)){ 
                 eventSelectOnCondition = true;
                 conditions = eventObj.conditionArr.join(",");
                 skipConditions = eventObj.skipConditionArr.join(",");
                 if (eventObj.conditionArr.length > 0){
                    conditionConnector = eventObj.conditionConnector;
                 }
        }
        let eventString = {eventNbr: this.eventNbr, eventTitle: eventObj.title, description:  eventObj.description, 
                    frequency: eventObj.frequency, condition: conditions, conditionConnector: conditionConnector,
                    skipCondition: skipConditions, selectOnCondition: eventSelectOnCondition,
                    background: eventObj.backgroundType, gamePhase: eventObj.gamePhase, 
                    eventCategory: eventObj.eventCategory, careerTag: eventObj.careerTag, 
                    imageDirectory: eventObj.imageDir};                 
        this.eventHeaderListArr.push(eventString);
    }

    rptEventsList(){
        this.eventListArr = []
        var i;
        for (i=0; i<this.adminInfo.eventsData.length; i++){
            if (i === 0){
                this.eventsListHeading();
            }
            this.eventNbr = i + 1;
            let eventObj = this.adminInfo.eventsData[i];
            this.buildEventListObj(eventObj);
        }
        this.rptTitle = "EventsList";
        this.rptLines = this.eventListArr;
        this.exportReportDataset();
    }

    eventsListHeading(){
        let eventString = {eventNbr: "Event Nbr", title: "Event Title", description: "Event Description",
            frequency: "Frequency", condition: "Condition", skipCondition: "Skip Condition", 
            selectCondSwitch: "Select Cond Switch", buttonTxt: "Button Text", closureTxt: "Closure Text",
            category: "Category", onField: "On Field", type: "Type", duration: "Duration", odds: "Odds",
            replaceAmtSw: "Replace Amt Sw", triggerCond: "Trigger Condition", deleteCond: "Delete Condition",
            deleteClass: "Delete Class", resultCondSwitch: "Result Cond Switch", values: "Values"};
        this.eventListArr.push(eventString);
    }
       
    buildEventListObj(eventObj){
        var i;
        var j;
        var eventSelectOnCondition = false;
        var eventResponseCondition = false;
        for (i=0; i<eventObj.responses.length; i++){
            let response = eventObj.responses[i];
            for (j=0; j<response.possibleEffects.length; j++){
                let possible = response.possibleEffects[j]; 
                if ((eventObj.condition  && eventObj.condition !== "") ||
                    (eventObj.skipCondition  & eventObj.skipCondition !== "")){ 
                        eventSelectOnCondition = true;
                }
                if ((possible.triggerCondition  && possible.triggerCondition !== "") ||
                    (possible.deleteCondition  && possible.deleteCondition !== "") ||
                    (possible.deleteClass  && possible.deleteClass !== "")){
                        eventResponseCondition = true;
                }
                let eventString = {eventNbr: this.eventNbr, title: eventObj.title, description: eventObj.description,
                    frequency: eventObj.frequency, condition: eventObj.condition, skipCondition: eventObj.skipCondition, 
                    selectCondSwitch: eventSelectOnCondition, buttonTxt: response.btnText, closureTxt: possible.closureText,
                    category: possible.category, onField: possible.on, type: possible.type, duration: possible.duration,
                    odds: possible.odds, replaceAmtSw: possible.replaceAmtSw, triggerCond: possible.triggerCondition, 
                    deleteCond: possible.deleteCondition, deleteClass: possible.deleteClass, 
                    resultCondSwitch: eventResponseCondition, values: possible.possibleValues.join()};
                this.eventListArr.push(eventString);
            }
        }
    }
    //   this report no longer supported.
    rptEventsByPlayerTitle(){
       
    } 

    createEventsAuditRpt(rptParameters){
        this.setState({openRptParameterModal: false});
        this.selectDataRcds(rptParameters);
        (this.slctEventsTracker).sort((a, b) => 
            (a.eventNbr > b.eventNbr) ? 1 : -1);
        this.rptArr = rptEventsAudit(this.slctEventsTracker, rptParameters);
        this.rptTitle = "Events Audit Rpt";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    selectDataRcds(rptParameters){
        this.slctEventsTracker = [];
        for (let i=0; i<this.eventsTrackerData.length; i++){
            if (this.eventsTrackerData[i].user === rptParameters.player){
                if (rptParameters.gameID === "" ||
                    rptParameters.gameID === this.eventsTrackerData[i].gameID){
                        this.slctEventsTracker.push(this.eventsTrackerData[i]);
                }
            }
        }
    }

    createRptEventsWithConditions(){
        this.rptArr = rptEventsWithConditions(this.adminInfo.conditionsData, this.adminInfo.eventsData )
        this.rptTitle = "Events With Conditions";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    createRptMoodPointsByEventRpt(){
        //  select if the mood points are either less than the low point or greater than the high point
        let moodPointLow = -5;
        let moodPointHigh = 5;
        this.rptArr = rptMoodPointsByEvent(this.adminInfo.eventsData, moodPointLow, moodPointHigh);
        this.rptTitle = "Mood Points by Event";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    createRptMoodPointAnalysis(){
        //  create report that counts and sums mood points by gamePhase, category and sub-category
        this.rptArr = rptMoodPointAnalysis(this.adminInfo.eventsData);
        this.rptTitle = "Mood Point Analysis";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    eventFrequencyAnalysisRpt(detailType){
        if (detailType === "Detail"){
            const selectedEvents = this.adminInfo.eventsData.filter(item => item.title === "Fun Fact");
            // const selectedEvents = this.adminInfo.eventsData.filter(item => !item.careerTag) 
            // this.rptArr = rptFrequencyErrors(this.adminInfo.eventsData);
            this.rptArr = rptFrequencyAnalysisDetail(selectedEvents);
        }else{
            const selectedEvents = this.adminInfo.eventsData.filter(item => item.careerTag !== "" &&
                item.careerTag !== undefined
            )
            this.rptArr = rptFrequencyAnalysisSummary(selectedEvents);
        }
        // this.rptArr = rptFrequencyAnalysisSummary(this.adminInfo.eventsData);
        this.rptTitle = "Event Frequency Analysis - " + detailType;
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    createRptMissingCreditInfo(){
        this.rptArr = rptMissingCreditInfo(this.adminInfo.eventsData);
        this.rptTitle = "Missing Credit Card Fields";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    async createEventAnalysisRpt(){
        await this.loadEventArr();
        this.rptArr = rptEventAnalysis(this.adminInfo.eventsData, this.eventArrData.eventArr);
        this.rptTitle = "Event Analysis";
        this.rptLines = this.rptArr;
        this.exportReportDataset();
    }

    exportReportDataset() {
        this.setState({exportToExcelButton: true});    
    }

   removeExportButton(){
        this.setState({exportToExcelButton: false});
   }

   getRptParameters(rptTitle){
       if (rptTitle === "EventsAudit"){
            this.getEventsTracker();
            this.rptTitle = "Events By Player Audit Report";
       }
      
   }

   openVariableEventModal(){
        this.variableEvents = this.adminInfo.eventsData.filter(item => item.varEvent === true);
        this.loadVariableEvents();
   }

   closeVariableEventModal(){
        this.setState({openVariableEvents: false});
   }

   closeParameterModal(){
       this.setState({openRptParameterModal: false});
   }
         
    render() {
       
    return <>
        <div className="col-sm-6 mb-5 input-page-base-card">
            <div className="card mt-3 mr-5 rounded-corners-lg height-max">
                <h1 className="mt-2 p-0 text-center">Game Administration</h1>
                <h4 className="text-center">Event Collection Reports</h4>
                <div className="text-center">
                <div className="row">
                    <div className="col-6 mt-2">
                        <button className="btn-group-medium text-center" 
                                onClick ={()=> this.editEventsCollection()}>
                                    Edit Events Collection
                        </button>
                    </div>
                    <div className="col-6 mt-2">
                        <button className="btn-group-medium" 
                            onClick ={()=> this.rptEventHeaderList()}>
                                    Event Header List
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-2">
                        <button className="btn-group-medium" 
                            onClick ={()=> this.rptEventsList()}>
                                    Events List With Responses
                        </button>
                    </div>
                    <div className="col-6 mt-2">
                        <button className="btn-group-medium" 
                            onClick ={()=> this.getRptParameters("EventsAudit")}>
                                Events by Player Audit Report
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-2">           
                        <button className="btn-group-medium"  
                            onClick ={()=> this.createRptEventsWithConditions()}>
                                Events With Conditions
                        </button>
                    </div>
                    <div className="col-6 mt-2">
                        <button className="btn-group-medium" 
                            onClick ={()=> this.createRptMoodPointsByEventRpt()}>
                                Mood Points by Event
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-2 ">       
                        <button className="btn-group-medium" 
                            onClick ={()=> this.createRptMoodPointAnalysis()}>
                                Mood Point Analysis Report
                        </button>
                    </div>
                    <div className="col-6 mt-2">     
                        <button className="btn-group-medium" 
                            onClick ={()=> this.createRptMissingCreditInfo()}>
                                Missing Item Desc or Credit Card Category
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-2">                 
                        <button className="btn-group-medium" 
                            onClick ={()=> this.eventFrequencyAnalysisRpt("Detail")}>
                                Event Frequency Detail
                        </button>
                    </div>
                    <div className="col-6 mt-2">                 
                        <button className="btn-group-medium" 
                            onClick ={()=> this.eventFrequencyAnalysisRpt("Summary")}>
                                Event Frequency Summary
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-2">    
                        <button className="btn-group-medium" 
                            onClick ={()=> this.createEventAnalysisRpt()}>
                                Event Analysis
                        </button>
                    </div>
                    <div className="col-6 mt-2">     
                        <button className="btn-group-medium" 
                            onClick ={()=> this.openVariableEventModal()}>
                               Edit Variable Events
                        </button>
                    </div>
                </div>
            </div>

            {this.state.waitState  ?
                <WaitTimeSpinner/>
            :
                <div>
                    {this.state.openRptParameterModal ?
                        <EventReportsInputModal openModal={this.state.openRptParameterModal} 
                            onClose={() => this.closeParameterModal()} 
                            onSubmit={(rptParameters) => this.createEventsAuditRpt(rptParameters)}
                            rptTitle={this.rptTitle}
                        />
                    :
                        <>
                            {this.eventsTrackerData === "NoEventTrackerData"  ?
                                <h4 className="text-danger text-center mt-4">
                                    No Event Tracker Data Exists
                                </h4>
                            :
                                null
                            }
                        </>
                    }
                    {this.state.openVariableEvents   ?
                        <EditVariableEventsModal
                            openModal={this.state.openVariableEvents}
                            variableEvents={this.variableEvents}
                            variableEventResponses={this.variableEventResponses}
                            onClose={() => this.closeVariableEventModal()}
                        />
                     
                    :
                        null
                    }
                    {this.state.exportToExcelButton ?
                        <ExportToExcelButton
                            fileName={this.rptTitle}
                            rptHeader={this.rptHeader}
                            data={this.rptLines}
                            exportComplete={() => this.removeExportButton()}
                        />
                    :
                        null
                    }
                </div>               
            }
                   
            </div>        
        </div>
    </>
    }
 
getEventsTracker() {
    this.setState({waitState: true});
    const funcName = "loadEventTracker";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.eventsTrackerData = output.body;
                        this.setState({openRptParameterModal: true, waitState: false});
                    }else{
                        if (statusCode === 250){
                            this.eventsTrackerData = "NoEventTrackerData";
                            this.setState({openRptParameterModal: false, waitState: false});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
}


loadVariableEvents() {
    this.setState({waitState: true});
    const funcName = "getVariableEventsList";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.variableEventResponses = output.body;
                        this.setState({openVariableEvents: true, waitState: false});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

async loadEventArr() {
    this.setState({ waitState: true });
    const gameID = "699bb56c1d6baf64724eb751";
    const urlParm = "?gameID=" + gameID;
    const funcName = "loadEventArr";
    try {
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        const response = await fetch(uri, {
            method: 'GET',
            headers: this.state.headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const output = JSON.parse(data);   // Remove this if backend already returns JSON
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            this.eventArrData = output.body;
            this.setState({
                eventArrLoaded: true,
                waitState: false
            });

        } else if (statusCode === 250) {
            const eventArrObj={title: "No EventArr Data Found", eventID: "None", frequency: 9999,
                gameDate: "9999/99/99" };
            this.eventArrData = {eventArr: [eventArrObj]};
            this.setState({
                eventArrLoaded: true,
                waitState: false
            });

        } else {
            this.props.processError({
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body?.message
            });

            this.setState({ waitState: false });
        }

    } catch (error) {
        console.error("loadEventsArr error:", error);

        this.setState({ waitState: false });

        this.props.processError({
            function: funcName,
            subProcess: this.state.subProcess,
            status: "FETCH_ERROR",
            message: error.message
        });
    }
}

}

export default EventReports;